import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import privateAxios from '../../utils/axios/privateAxios';
import publicAxios from '../../utils/axios/publicAxios';
import './AddToTeam.css';
import Notification from '../../components/Notification/Notification';
import { Link, useNavigate } from 'react-router-dom';
import { formats, modules, memberCategories } from '../../assets/exports';
import { jwtDecode } from 'jwt-decode';


const AddToTeam = () => {
  const navigate = useNavigate();

  const [decodedData, setDecodedData] = useState({});
  const userRoles = decodedData?.userRoles || [];
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [display, setDisplay] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');
  const [category, setCategory] = useState(userRoles[0] || '');
  const [notification, setNotification] = useState({ type: '', message: '' });

  const showNotification = (type, message) => {
    setNotification({ type, message });
    setTimeout(() => {
      setNotification({ type: '', message: '' });
    }, 5000);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImageFile(file);
    setPreviewUrl(URL.createObjectURL(file));
  };

  const uploadImageToS3 = async () => {
    if (!imageFile) return '';

    try {
      const response = await privateAxios.get('/private/generate-upload-url', {
        params: {
          filename: imageFile.name,
          filetype: imageFile.type,
        },
      });

      const { url } = response.data;
      await publicAxios.put(url, imageFile);

      return url.split('?')[0];
    } catch (error) {
      console.error('Image upload failed:', error);
      throw new Error('Failed to upload image.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus('');

    try {
      let uploadedImageUrl = '';
      if (imageFile) {
        uploadedImageUrl = await uploadImageToS3();
      }

      const postData = {
        title,
        content,
        display,
        imageUrl: uploadedImageUrl || '',
        category, // 👈 Include category
      };

      await privateAxios.post(`/private/add-to-team`, postData);

      showNotification('success', 'Added to team successfully!');
      setTitle('');
      setContent('');
      setDisplay(false);
      setImageFile(null);
      setPreviewUrl('');
      setCategory(userRoles[0] || '');

      setTimeout(() => navigate('/admin-our-team'), 3000);
    } catch (error) {
      console.error(error);
      showNotification('error', error.message || 'Error adding to team.');
      setStatus('Error adding to team.');
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    const token = localStorage.getItem('token');

    // Ensure token exists before decoding
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setDecodedData(decoded);
      } catch (err) {
        console.error('Invalid token:', err);
        // Handle invalid token if necessary (e.g., redirect to login)
        navigate('/login');
      }
    }
  }, [navigate]);

  return (
    <div className="add-to-team">
      <Notification
        type={notification.type}
        message={notification.message}
        onClose={() => setNotification({ type: '', message: '' })}
      />

      <Link to={'/admin-our-team'} className="add-to-team-back-to-our-team">
        Back to Our Team
      </Link>

      <h2>Add to Team</h2>

      <form onSubmit={handleSubmit}>
        <label>Member Name:</label>
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />

        <label>Bio (optional):</label>
        <ReactQuill
          value={content}
          onChange={setContent}
          theme="snow"
          modules={modules}
          formats={formats}
        />

        <label>Category:</label>
        <select className='add-to-team-select-category' value={category} onChange={(e) => setCategory(e.target.value)} required>
          {memberCategories.map((role) => (
            <option key={role} value={role}>
              {role.charAt(0).toUpperCase() + role.slice(1)}
            </option>
          ))}
        </select>

        {userRoles.includes('admin') && (
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={display}
              onChange={() => setDisplay(!display)}
            />
            Display
          </label>
        )}

        <label>Upload Image (optional):</label>
        <input type="file" accept="image/*" onChange={handleImageChange} />
        {previewUrl && (
          <div className="uploaded-image-preview">
            <img src={previewUrl} alt="Selected preview" />
          </div>
        )}

        <button type="submit" disabled={loading}>
          {loading ? 'Adding...' : 'Add'}
        </button>
      </form>

      {status && <p className="status-message">{status}</p>}
    </div>
  );
};

export default AddToTeam;